<template>
    <el-drawer :title="formData.type == 1 ? '按手机号发放' : '生成兑换码'" :visible.sync="drawerShow" :wrapperClosable="false"
        :destroy-on-close="true" size="auto" @close="close">
        <div class="drawer-content">
            <el-alert type="warning" :closable="false">
                <span slot="title">赠票名称: {{ ticketData && ticketData.ticketName }}</span>
            </el-alert>
            <el-form :model="formData" :rules="rules" ref="formData" label-position="top" class="MT10">
				<el-form-item prop="realName" label="是否实名:" v-if="ticketData">
					<span v-if="ticketData.realName == 1">实名制</span>
					<span v-else>非实名制</span>
				</el-form-item>
                <template v-if="formData.type == 1">					
                    <el-form-item prop="tel" label="接收手机:">
                        <el-input v-model="formData.tel" placeholder="目前仅支持大陆11位手机号" size="medium"></el-input>
                    </el-form-item>
                    <el-form-item prop="num">
                        <span slot="label">
                            发放数量:
                            <small>
                                已发放有效赠票数量:<span class="color-danger">{{ hasSendNum }}</span>,
                                还可以发放的数量:<span class="color-danger">{{ canSendNum }}</span>
                            </small>
                        </span>
                        <el-input-number style="width:100%" v-model="formData.num" :min="0" :max="canSendNum"
                            :precision="0" :controls="false" placeholder="大于0的整数"></el-input-number>
                        <small v-if="ticketData && ticketData.realName == 1 ">发放多张<span class="color-danger">实名制</span>赠票，用户只会收到1条短信，需进入票夹后查看所有赠票</small>
						<small v-if="ticketData && ticketData.realName == 0 ">发放多张<span class="color-danger">非实名制</span>赠票，则每张赠票都会发送1条短信，同一个手机号单日内接收赠票短信数<span class="color-danger">理论上限不能大于30条</span></small>
                    </el-form-item>
                    <el-form-item prop="remark" label="备注:">
                        <el-input v-model="formData.remark" placeholder="如赠送原因,最多100个字符" size="medium" maxlength="100" :rows="4"
                            type="textarea" show-word-limit></el-input>
                    </el-form-item>
                </template>
                <el-form-item v-else prop="num" label="生成兑换码数量">
                    <el-input-number style="width:100%" v-model="formData.num" :min="1" :max="10000" :precision="0"
                        :controls="false" placeholder="请输入生成兑换码数量"></el-input-number>
                </el-form-item>
				<el-form-item prop="invalidTime" label="兑换截止时间"  v-if="formData.type ==2 && ticketData.presentTicketType != 1">
				    <el-date-picker v-model="formData.invalidTime" type="datetime" placeholder="请填写兑换截止时间" value-format="yyyy-MM-dd HH:mm:ss" size="medium"></el-date-picker>
				</el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    num: undefined,
    remark: '',
    tel: '',
    type: 1,
	invalidTime:''
}
export default {
    props: {
        activityId: {
            type: [Number, String],
            default: ''
        },
    },
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            formData: {
                ...defaultFormData
            },
            rules: {
                tel: [
                    { required: true, message: "请输入接收手机号码" },
                    { validator: this.$utils.validatePhone },
                ],
                num: [{ required: true, message: "请输入数量" }],
				invalidTime: [{ required: true, message: "请填写兑换截止时间" }],
            },
            ticketData: null,
            canSendNum: 0,
            hasSendNum: 0
        }
    },
    methods: {
        close() {
            this.formData = { ...defaultFormData };
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show(data, type) {
            this.ticketData = data;			
            this.formData.type = type;
			this.formData.invalidTime = data.lastEndSessionTime
            if (type == 1) {
                this.getPresentNum();
            }
            this.drawerShow = true;
        },
        //获取赠票数量
        async getPresentNum() {
            const res = await this.$request({
                url: '/activity/presentNum',
                params: { ticketPriceId: this.ticketData.id },
                method: "post",
            });
            const { state, result } = res.data;
            if (state == 1) {
                this.canSendNum = result.canSendNum;
                this.hasSendNum = result.hasSendNum;
            }
        },
        //表单提交
        submitForm() {
			if( this.formData.type == 1 && this.canSendNum == 0){
                return this.$message.error("还可以发放的数量为0，不可继续发放");
            }
            this.$refs["formData"].validate(async (valid) => {
                if (valid) {
                    this.btnLoading = true;
                    const res = await this.$request({
                        url: '/activity/sendPresent',
                        data: { ...this.formData, ticketPriceId: this.ticketData.id, activityId: this.activityId },
                        method: "post",
                    }).catch(() => {
                        this.$message.error("操作失败,请重试");
                    }).finally(() => {
                        this.btnLoading = false;
                    });

                    const { state, msg } = res.data;
                    if (state == 1) {
                        this.$emit('onUpdate');
                        this.close();
                    } else {
                        this.$message.error(msg || "操作失败,请重试");
                    }
                } else {
                    return false;
                }
            });
        },
    }
}
</script>